import { useSelector } from 'react-redux';

import getVehicleTypesSelector from '/business/shared/state/selectors/application/step1/getVehicleTypesSelector';
import vehicleTypeDisplayName from '/business/shared/util/vehicleTypeDisplayName';
import type { VehicleType } from '/index';

type VehicleTypeNameProps = {
  name: string;
};

// Answers store the vehicle tree's slug ('busescoaches'); show the label the form offered.
function VehicleTypeName({ name }: VehicleTypeNameProps) {
  const vehicleTypes: VehicleType | undefined = useSelector(getVehicleTypesSelector);
  const vehicleType = vehicleTypes?.items.find((item) => item.name === name);

  if (!vehicleType) {
    return <>{name}</>;
  }
  return <>{vehicleTypeDisplayName(vehicleType.name, vehicleType.title)}</>;
}

export default VehicleTypeName;
